
<template>
<!-- eslint-disable no-mixed-spaces-and-tabs -->
  <v-app>

	<v-container v-show="!isLogin">
	<v-dialog v-model="loginForm" v-if="!isLogin" persistent >
	<v-form >
		<v-container>
		<v-layout row wrap><v-flex>
        <v-text-field ref="loginid" 
		v-model="login.id"
		label="LoginID"
		required
		v-on:keyup="goLogin"
		></v-text-field>
		<v-text-field
		v-model="login.pswd"
		label="Password"
		:type="'password'"
		required
		v-on:keyup="goLogin"
		></v-text-field>
		</v-flex>
		</v-layout>
	    <v-btn
	      color="success"
	      @click="doLogin"
	    >Login</v-btn>
    		</v-container>
    </v-form>
    </v-dialog>
	</v-container>
	<v-container v-show="isLogin">
		<v-toolbar >
			<v-toolbar-title>RhythmVue</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn text flat small @click="selectMenuMail" v-if="mailButton">Mail</v-btn>
			<v-btn text flat small @click="selectMenuSchedule">Schedule</v-btn>
			<v-btn text flat small @click="selectMenuTimecard">Timecard</v-btn>
			<v-btn text flat small @click="selectMenuWorkStatus">WorkStatus</v-btn>
		</v-toolbar>
		<Mail ref="mail" v-bind:member="member" v-show="selectedMenu == 'Mail'" v-on:needLogin="relogin()" v-on:mailUnusable="disableMail()"></Mail>
		<Schedule ref="schedule" v-show="selectedMenu == 'Schedule'" v-on:needLogin="relogin()"></Schedule>
		<Timecard ref="timecard" v-show="selectedMenu == 'Timecard'" v-on:needLogin="relogin()"></Timecard>
		<WorkStatus ref="workstatus" v-show="selectedMenu == 'WorkStatus'" v-on:needLogin="relogin()"></WorkStatus>
	</v-container>
  </v-app>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
import axios from 'axios';
import Cookies from 'js-cookie';
import Mail from './components/Mail.vue';
import Schedule from './components/Schedule.vue';
import Timecard from './components/Timecard.vue';
import WorkStatus from './components/WorkStatus.vue';

export default {
	name: 'App',
	components: {
		Mail, Schedule, Timecard, WorkStatus
	},
	data() {
		return { 
			isLogin: false,
			firstLogin: true,
			login: {
				id: null,
				pswd: null,
			},
			member: null,
			selectedMenu: "Mail",
			loginForm: {},
			mailButton: true,
		};
	},
	mounted() {
		this.$refs.loginid.focus();
	},
	methods: {
		disableMail: function() {
			this.selectMenuSchedule();
			this.mailButton = false;
		},
		selectMenuMail: function() {
			this.selectedMenu = "Mail";
		},
		selectMenuSchedule: function() {
			this.selectedMenu = "Schedule";
		},
		selectMenuTimecard: function() {
			this.selectedMenu = "Timecard";
		},
		selectMenuWorkStatus: function() {
			this.selectedMenu = "WorkStatus";
		},
		relogin: function() {
			this.isLogin = false;
		},
		goLogin: function(e) {
			if (e.keyCode === 13) {
				this.doLogin();
			}
		},
		doLogin: function() {
			axios.post("api_login", null, {
				params: {
					loginid: this.login.id,
					password: this.login.pswd,
					}
			}).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
					this.isLogin = true;
					this.member = appResp.data;
					if (this.firstLogin) {
						this.$refs.schedule.initDisp();
						this.$refs.timecard.initDisp();
						this.$refs.workstatus.initDisp();
						this.$refs.mail.initDisp();
					}
					this.firstLogin = false;
				} else {
					Cookies.remove('rhythmSession');
					this.isLogin = false;
				}
			});
		},
	},
}
</script>


<style>
.v-dialog {
  background: white;
}
</style>
